import { ReactNode } from 'react';
import { RecommendedProductsCarousel } from '@/entities/product/ui/recommended-products-carousel';
import './product-detail.scss';

type Props = {
    children?: ReactNode;
};

export const ProductDetailRecommendedCarousel = ({ children }: Props) => {
    return (
        <>
            <h2 className="product-detail__recommended-carousel-title">Doporučujeme</h2>
            <RecommendedProductsCarousel className="product-detail__recommended-carousel-content">
                {children}
            </RecommendedProductsCarousel>
        </>
    );
};
